import { CanActivate } from '@angular/router';
import { Action, Selector, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, filter, switchMap, take, tap } from 'rxjs/operators';

/**
 * A generic guard to make sure UI data is available for retrieval
 * when the new route is loaded
 */
export class GenericGuard<T> implements CanActivate {
  constructor(
    private store: Store<T>,
    private isLoadedSelector: Selector<T, boolean>,
    private callbackActionClassIfNotLoaded: { new (...args: any[]): Action },
    private callbackActionArgsIfNotLoaded: any[] = null
  ) {}

  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.select(this.isLoadedSelector).pipe(
      tap(loaded => {
        if (!loaded) {
          this.store.dispatch(
            new this.callbackActionClassIfNotLoaded(
              this.callbackActionArgsIfNotLoaded
            )
          );
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
